
import { Component, Mixins, Emit } from "vue-property-decorator";
import { Point } from "../../../../../domain/drawing";
import { IDrawableItem } from "../../../../../domain/document/items";
import { DragKinds } from "../../../../dragging/DragKinds";
import { DragParameter } from "../../../../dragging/DragParameter";

@Component({
})
export default class DraggableMixin extends Mixins() {
  editingSource: IDrawableItem;

  @Emit()
  dragHandleSelected(source: IDrawableItem, parameter: DragParameter): void {}

  draggableItemHandleSelected(event: PointerEvent, kind: DragKinds, container: HTMLDivElement, isAspectRasioFixed: boolean = false) {
    const rect = container.getBoundingClientRect();
    const parameter = new DragParameter(
      kind,
      new Point(event.clientX - rect.left, event.clientY - rect.top),
      isAspectRasioFixed);
    this.dragHandleSelected(this.editingSource, parameter);
  }
}
